// Copyright (c) Bentley Systems
import { ActionParameterVm } from "../../Action/action-parameter-vm";
import { ActionVm } from "../../Action/action-vm";
import { Parameter } from "../../Action/parameter";
import { Style } from "../../DataModels/style";
import { ArchiveDocument } from "./archive-document";
import { DocumentVersion } from "./document-version";

export class ArchiveVm {
  public caption?: string;
  public isMapping: boolean;
  public documents: ArchiveDocument[] = [];
  public headerActions: ActionVm[] = [];
  public headerBackAction: ActionVm | undefined;
  public urlParameters: Parameter[] = [];

  constructor(dataResult: any, urlParameters: Parameter[]) {
    this.caption = dataResult.caption;
    this.isMapping =
      dataResult.isImportMapping === true ||
      dataResult.isUpdateUserNames === true;
    this.urlParameters = urlParameters;
    const docs = dataResult.documents;
    docs.forEach(
      (doc: {
        id: number;
        nodeId: number;
        name: string;
        created: Date;
        version: {
          id: number;
          versionCount: number;
          originalFileName: string;
          note: string | undefined;
        };
        description: string | undefined;
      }) => {
        this.documents.push(
          new ArchiveDocument(
            doc.id,
            doc.nodeId,
            doc.name,
            doc.created,
            new DocumentVersion(
              doc.version.id,
              doc.version.versionCount,
              doc.version.originalFileName,
            ),
            doc.description,
          ),
        );
      },
    );
    const actions = dataResult.eaActions;
    actions
      .filter(
        (a: { actionType: string; actionOrder: undefined }) =>
          a.actionType === "H" && a.actionOrder !== undefined,
      )
      .sort(
        (a: { actionOrder: number }, b: { actionOrder: number }) =>
          (a.actionOrder) - (b.actionOrder),
      )
      .forEach(
        (a: {
          eaActionTexts: { caption: string | undefined }[];
          actionId: number | undefined;
          targetNodeType: string | undefined;
          targetNodeId: number | undefined;
          f_BACK: boolean;
          style: Style | undefined;
          eaActionParams: {
            value: string | undefined;
            name: string | undefined;
            actionParamId: number | undefined;
            valueType: string | undefined;
          }[];
        }) => {
          const action = new ActionVm();
          if (a.eaActionTexts !== undefined && a.eaActionTexts.length > 0) {
            action.caption = a.eaActionTexts[0].caption;
          }
          action.actionId = a.actionId;
          action.targetNodeType = a.targetNodeType;
          action.targetNodeId = a.targetNodeId;
          action.isBackHeaderButton = a.f_BACK;
          action.style = a.style;

          if (a.eaActionParams !== undefined && a.eaActionParams.length > 0) {
            for (const param of a.eaActionParams) {
              const par = new ActionParameterVm();
              par.actionParamId = param.actionParamId;
              par.name = param.name;
              par.value = param.value;
              par.valueType = param.valueType;
              if (par.valueType === "P") {
                const urlPar = this.urlParameters.find(
                  (p) => p.name === par.name,
                );
                if (urlPar != null) {
                  par.value = urlPar.value;
                }
              }
              action.actionParameters.push(par);
            }
          }
          if (action.isBackHeaderButton) {
            this.headerBackAction = action;
          } else {
            this.headerActions.push(action);
          }
        },
      );
  }
}
